import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import i18n, { t } from '@moovly/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configuration, getDefaultMiddleWare } from '@moovly/clients';
import SentryService from './services/Sentry';
SentryService.init();
configuration.setMiddlewares(getDefaultMiddleWare(t));
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

i18n.setGlobalParam('platformName', 'VideoCreator Pro');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
